<template>
  <div>
    <table
      id="headerTable"
      class="table is-fullwidth is-bordered"
    >
      <tr>
        <column-header
          v-for="(column, idx) in columns"
          :colspan="1"
          :key="column.column.id"
          :column="column"
          :index="idx"
          :filter-list-height="filterListHeight"
          my-class="header-column"
        ></column-header>
      </tr>
    </table>

    <table
      id="dataTable"
      class="table is-bordered is-fullwidth is-striped"
    >
      <table-row
        v-for="(dataset, idx) in filteredDatasets"
        :firstRow="idx === 0"
        :key="dataset.id"
        :row="parse(dataset.columns)"
        @tableReady="setColumnWidths"
      ></table-row>

      <tr class="footer">
        <column-footer
          v-for="column in columns"
          :key="column.column.id"
          :column="column.column"
          :values="getColumnValues(column.column.id)"
        ></column-footer>
      </tr>

      <tr>
        <column-header
          v-for="(column, idx) in columns"
          :colspan="1"
          :key="column.column.id"
          :column="column"
          :index="idx"
          :filter-list-height="filterListHeight"
          my-class="guide-column"
        ></column-header>
      </tr>
    </table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TableRow from '@/components/reports/TableRow'
import ColumnHeader from '@/components/columns/ColumnHeader'
import ColumnFooter from '@/components/columns/ColumnFooter'

export default {
  name: 'GridReport',

  components: {
    TableRow,
    ColumnHeader,
    ColumnFooter
  },

  data () {
    return {
      copy: null,
      sortColumnId: 0,
      filterListHeight: 250,
      fixedHeaderThreshold: 370
    }
  },

  computed: {
    ...mapGetters({
      order: 'reports/order',
      report: 'reports/report',
      bundle: 'bundles/bundle',
      columns: 'columns/columns',
      filters: 'filters/filters',
      datasets: 'datasets/datasets',
    }),

    filteredDatasets () {
      if (this.filters.length === 0) return this.datasets

      return this.datasets.filter((dataset) => {
        const result = this.filters.map((filter) => {
          const value = dataset.columns.find(x => {
            return (x) ? x.id === filter.columnId : filter.showEmpty
          })

          if (!value.value.value) return filter.showEmpty

          return filter.filter.includes(value.value.id)
        })

        return result.every(pass => pass)
      })
    },
  },

  mounted () {
    this.$nextTick(() => {
      this.setFilterListHeight()
    })
    
    window.addEventListener('resize', this.setColumnWidths)
    window.addEventListener('resize', this.setFilterListHeight)
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.setColumnWidths)
    window.removeEventListener('resize', this.setFilterListHeight)
  },

  methods: {
    setColumnWidths () {
      const guideWidths = Array.from(document.getElementsByClassName('guide-column')).map(col => col.clientWidth)

      Array.from(document.getElementsByClassName('header-column')).forEach((col, key) => col.setAttribute('style', `width: ${guideWidths[key] + 1}px;`))
    },

    setFilterListHeight () {
      this.filterListHeight = Math.ceil(window.innerHeight * 0.6)
    },

    getColumnValues (columnId) {
      return this.filteredDatasets.map(dataset => {
        return dataset.columns.filter(column => (column.value) ? column.id === columnId : false)
      }).flat()
    },

    parse (columns) {
      return columns.map(column => column.value.value)
    }
  }
}
</script>

<style scoped>
  .field button {
    margin-bottom: 15px;
  }

  #headerTable {
    position: sticky;
    top: 51px;
    z-index: 39;
    margin-bottom: 0;
    table-layout: fixed;
  }

  #dataTable tr:last-child {
    visibility: hidden;
  }

  #dataTable tr:last-child th {
    border-color: white;
  }
</style>
